import type { ReactNode } from "react";
import { Footer } from "./Footer";
import { WhatsAppFloating } from "./WhatsAppFloating";
import { useScrollDepth } from "@/hooks/useScrollDepth";

/**
 * Wrapper para páginas que NÃO são a Home.
 * A Home tem seu próprio footer + WhatsApp flutuante embutidos
 * (serão extraídos na Fase 2). Esse wrapper evita duplicação.
 */
export function PageShell({ children }: { children: ReactNode }) {
  useScrollDepth();
  return (
    <>
      {children}
      <Footer />
      <WhatsAppFloating />
    </>
  );
}
